<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useRoute } from '#app'

const route = useRoute()
const isSocialOpen = ref(false)
const isMobile = ref(false)

const checkMobile = () => {
    isMobile.value = window.innerWidth < 768
}

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
}

const toggleSocial = () => {
    if (!isMobile.value) return
    isSocialOpen.value = !isSocialOpen.value
}

const closeSocial = () => {
    isSocialOpen.value = false
}

// Инициализация и обработка ресайза
onMounted(() => {
    if (process.client) {
        checkMobile()
        window.addEventListener('resize', checkMobile)
    }
})

onUnmounted(() => {
    if (process.client) {
        window.removeEventListener('resize', checkMobile)
    }
})

// Закрытие меню при изменении размера на десктоп
watch(isMobile, (newVal) => {
    if (!newVal) closeSocial()
})

// Закрытие при смене роута
watch(() => route.path, closeSocial)

// Закрытие при клике вне области
if (process.client) {
    document.addEventListener('click', (e) => {
        const socialBtn = document.querySelector('.social-btn')
        const socialMenu = document.querySelector('.social-menu')

        if (socialBtn && socialMenu &&
            !socialBtn.contains(e.target) &&
            !socialMenu.contains(e.target)) {
            closeSocial()
        }
    })
}
</script>

<template>
    <div class="pb-[70px] md:pb-0 bg-brand-bright"></div>
    <div class="block md:hidden bg-brand-blue fixed bottom-0 w-full z-30">
        <div class="container flex items-center justify-between">
            <NuxtLink active-class="bg-[#149CFD]" to="/" class="flex flex-col items-center gap-2 py-1.5 px-3">
                <img src="/img/icons/mobile/home.svg" width="25" height="25" alt="Главная">
                <p class="font-medium text-white text-[10px]">Главная</p>
            </NuxtLink>
            <NuxtLink active-class="bg-[#149CFD]" to="/catalog" class="flex flex-col items-center gap-2 py-1.5  px-3">
                <img src="/img/icons/mobile/catalog.svg" width="25" height="25" alt="Каталог">
                <p class="font-medium text-white text-[10px]">Каталог</p>
            </NuxtLink>
            <span @click="scrollToTop" class="flex flex-col items-center gap-2 py-1.5  px-3">
                <img src="/img/icons/mobile/up.svg" width="18" height="18" alt="Вверх">
                <p class="font-medium text-white text-[10px]">Вверх</p>
            </span>
            <NuxtLink active-class="bg-[#149CFD]" to="/favorites" class="flex flex-col items-center gap-2 py-1.5 px-3">
                <img src="/img/icons/mobile/saved.svg" width="25" height="25" alt="Избранное">
                <p class="font-medium text-white text-[10px]">Избранное</p>
            </NuxtLink>
            <!-- <NuxtLink to="#" class="flex flex-col items-center gap-2  px-3">
                <img src="/img/icons/mobile/exit.svg" alt="">
                <p class="font-medium text-white text-[10px]">Выход</p>
            </NuxtLink> -->
            <button @click.stop="toggleSocial" class="social-btn flex flex-col items-center gap-1.5 py-1.5 px-3"
                :class="{ 'bg-[#149CFD]': isSocialOpen }">
                <img src="/img/icons/mobile/social.svg" alt="social" width="23" height="23">
                <p class="font-medium text-white text-[10px]">Соцсети</p>
            </button>
        </div>
    </div>

    

    <!-- Анимированное меню соцсетей -->
    <transition enter-active-class="transition-all duration-300 ease-out"
        leave-active-class="transition-all duration-300 ease-in" enter-from-class="opacity-0 translate-y-10"
        enter-to-class="opacity-100 translate-y-0" leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 translate-y-10">
        <div v-show="isSocialOpen && isMobile" class="fixed right-4 bottom-24 z-50 flex flex-col gap-8">
            <!-- VK -->
            <div class="w-14 h-14 animate-[bounce-in_0.3s_ease-out]">
                <a rel="nofollow" href="https://vk.com/club_arendabc_sale" target="_blank"
                    class="block hover:scale-110 transition-transform">
                    <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                        <g id="" stroke-width="0"></g>
                        <g id="" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="">
                            <circle cx="512" cy="512" r="512" style="fill:#2787f5"></circle>
                            <path
                                d="M585.83 271.5H438.17c-134.76 0-166.67 31.91-166.67 166.67v147.66c0 134.76 31.91 166.67 166.67 166.67h147.66c134.76 0 166.67-31.91 166.67-166.67V438.17c0-134.76-32.25-166.67-166.67-166.67zm74 343.18h-35c-13.24 0-17.31-10.52-41.07-34.62-20.71-20-29.87-22.74-35-22.74-7.13 0-9.17 2-9.17 11.88v31.57c0 8.49-2.72 13.58-25.12 13.58-37 0-78.07-22.4-106.93-64.16-43.45-61.1-55.33-106.93-55.33-116.43 0-5.09 2-9.84 11.88-9.84h35c8.83 0 12.22 4.07 15.61 13.58 17.31 49.9 46.17 93.69 58 93.69 4.41 0 6.45-2 6.45-13.24v-51.6c-1.36-23.76-13.92-25.8-13.92-34.28 0-4.07 3.39-8.15 8.83-8.15h55c7.47 0 10.18 4.07 10.18 12.9v69.58c0 7.47 3.39 10.18 5.43 10.18 4.41 0 8.15-2.72 16.29-10.86 25.12-28.17 43.11-71.62 43.11-71.62 2.38-5.09 6.45-9.84 15.28-9.84h35c10.52 0 12.9 5.43 10.52 12.9-4.41 20.37-47.18 80.79-47.18 80.79-3.73 6.11-5.09 8.83 0 15.61 3.73 5.09 16 15.61 24.1 25.12 14.94 17 26.48 31.23 29.53 41.07 3.45 9.84-1.65 14.93-11.49 14.93z"
                                style="fill:#fff"></path>
                        </g>
                    </svg>
                </a>
            </div>

            <!-- WhatsApp -->
            <div class="w-14 h-14 animate-[bounce-in_0.3s_ease-out_0.1s]">
                <a rel="nofollow" href="https://wa.me/..." target="_blank"
                    class="block hover:scale-110 transition-transform">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 96 96"
                        id="Whatsapp-Icon--Streamline-Svg-Logos">
                        <path fill="url(#a)"
                            d="M3.20676 47.591c-.00237 7.924 2.06817 15.6613 6.00506 22.4808l-6.38174 23.301 23.84542-6.2524c6.5694 3.5806 13.9665 5.4706 21.4944 5.4725h.0199c24.7897 0 44.9692-20.1724 44.9796-44.9664.0048-12.0148-4.6698-23.3123-13.1629-31.812C71.5149 7.3153 60.2212 2.63217 48.1879 2.62695 23.3953 2.62695 3.21718 22.798 3.20676 47.591Z">
                        </path>
                        <path fill="url(#b)"
                            d="M1.60084 47.5769C1.598 55.7861 3.74293 63.8001 7.82006 70.8637L1.20947 95l24.70063-6.4765c6.8058 3.7109 14.4683 5.6672 22.2657 5.6701h.0199c25.6791 0 46.5836-20.8979 46.5945-46.5793.0042-12.4465-4.8386-24.15-13.6349-32.9544C72.3577 5.85655 60.6598 1.00521 48.1957 1 22.5119 1 1.61126 21.8945 1.60084 47.5769ZM16.3103 69.6474l-.9221-1.4641c-3.8772-6.1647-5.92355-13.2884-5.92071-20.6036C9.47603 26.2337 26.8483 8.86713 48.2104 8.86713 58.5551 8.8714 68.2777 12.904 75.59 20.221c7.3123 7.3175 11.3359 17.0448 11.333 27.3905-.0095 21.3465-17.3822 38.7154-38.7273 38.7154h-.0151c-6.9503-.0038-13.7666-1.8701-19.7114-5.3971l-1.4148-.8392-14.6578 3.8431 3.9137-14.2863Z">
                        </path>
                        <path fill="#ffffff"
                            d="M36.55 28.1053c-.8723-1.9389-1.79-1.9777-2.6197-2.0118-.6789-.0289-1.4555-.0271-2.2311-.0271-.7766 0-2.0379.2919-3.1044 1.4565-1.0675 1.1651-4.0753 3.9815-4.0753 9.7093 0 5.7284 4.1724 11.2634 4.7538 12.041.5823.7761 8.0542 12.9065 19.8876 17.5731 9.8349 3.8781 11.8363 3.1068 13.9708 2.9125 2.1345-.1938 6.8882-2.8154 7.8581-5.5341.9704-2.7182.9704-5.0484.6795-5.535-.291-.4852-1.0675-.7766-2.2317-1.3585-1.1646-.5823-6.8882-3.3991-7.9552-3.7876-1.0675-.388-1.8436-.5818-2.6202.5837-.7761 1.1642-3.0059 3.7858-3.6853 4.5624-.679.778-1.3584.8751-2.5226.2928-1.1646-.5842-4.9143-1.8123-9.3624-5.7781-3.4612-3.086-5.7976-6.8968-6.477-8.0624-.679-1.1641-.0725-1.7948.5112-2.3752.5231-.5216 1.1647-1.3593 1.747-2.0388.5809-.6799.7746-1.1651 1.1627-1.9417.3885-.777.1943-1.4569-.0967-2.0392-.2914-.5823-2.5538-6.3396-3.5891-8.6418Z">
                        </path>
                        <defs>
                            <linearGradient id="a" x1="4519.8" x2="4519.8" y1="9077.23" y2="2.631"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#1faf38"></stop>
                                <stop offset="1" stop-color="#60d669"></stop>
                            </linearGradient>
                            <linearGradient id="b" x1="4680.25" x2="4680.25" y1="9401.01" y2=".988"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#f9f9f9"></stop>
                                <stop offset="1" stop-color="#fff"></stop>
                            </linearGradient>
                        </defs>
                    </svg>
                </a>
            </div>

            <!-- Telegram -->
            <div class="w-14 h-14 animate-[bounce-in_0.3s_ease-out_0.2s]">
                <a href="https://t.me/..." rel="nofollow" target="_blank"
                    class="block hover:scale-110 transition-transform">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 96 96"
                        id="Telegram--Streamline-Svg-Logos">
                        <path fill="#00b6f4"
                            d="M48 1C35.5377 1 23.5747 5.95483 14.7695 14.7659 5.95703 23.5769 1 35.5399 1 48c0 12.4601 4.95703 24.4231 13.7695 33.2341C23.5747 90.0452 35.5377 95 48 95c12.4623 0 24.4253-4.9548 33.2305-13.7659C90.043 72.4231 95 60.4601 95 48c0-12.4601-4.957-24.4231-13.7695-33.2341C72.4253 5.95483 60.4623 1 48 1Z">
                        </path>
                        <path fill="#ffffff"
                            d="M22.2748 47.5041c13.7034-5.969 22.8391-9.9045 27.4069-11.8058 13.0572-5.4292 15.767-6.3722 17.5368-6.4041.3893-.0063 1.2558.0899 1.8213.5474.47.3856.6022.907.6683 1.2727.0587.3657.1395 1.1993.0734 1.8499-.705 7.4319-3.7673 25.4667-5.3242 33.7908-.6536 3.5222-1.9534 4.7031-3.2092 4.8184-2.7319.2511-4.8028-1.8036-7.4466-3.5362-4.1345-2.712-6.4698-4.3996-10.4869-7.0456-4.6412-3.0579-1.6303-4.7389 1.0135-7.4855.6903-.7189 12.7194-11.6574 12.947-12.6496.0294-.1241.0588-.5867-.2203-.8305-.2717-.2446-.6756-.1609-.9694-.0948-.4186.094-7.0206 4.4621-19.8281 13.1035-1.8727 1.2881-3.5691 1.916-5.0966 1.8829-1.6743-.036-4.9056-.9488-7.307-1.7287-2.9375-.9569-5.2801-1.4629-5.0745-3.088.1028-.846 1.2704-1.7119 3.4956-2.5968Z">

                        </path>
                        <defs>
                            <linearGradient id="a" x1="4701" x2="4701" y1="1" y2="9401" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#2aabee"></stop>
                                <stop offset="1" stop-color="#229ed9"></stop>
                            </linearGradient>
                        </defs>
                    </svg>
                </a>
            </div>
        </div>
    </transition>


    <div v-show="!isMobile">
        <div class="fixed bottom-[283px] right-6 w-[55px] h-[55px] z-50">
            <a rel="nofollow" href="https://vk.com/club_arendabc_sale" target="_blank">
                <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                    <g id="" stroke-width="0"></g>
                    <g id="" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="">
                        <circle cx="512" cy="512" r="512" style="fill:#2787f5"></circle>
                        <path
                            d="M585.83 271.5H438.17c-134.76 0-166.67 31.91-166.67 166.67v147.66c0 134.76 31.91 166.67 166.67 166.67h147.66c134.76 0 166.67-31.91 166.67-166.67V438.17c0-134.76-32.25-166.67-166.67-166.67zm74 343.18h-35c-13.24 0-17.31-10.52-41.07-34.62-20.71-20-29.87-22.74-35-22.74-7.13 0-9.17 2-9.17 11.88v31.57c0 8.49-2.72 13.58-25.12 13.58-37 0-78.07-22.4-106.93-64.16-43.45-61.1-55.33-106.93-55.33-116.43 0-5.09 2-9.84 11.88-9.84h35c8.83 0 12.22 4.07 15.61 13.58 17.31 49.9 46.17 93.69 58 93.69 4.41 0 6.45-2 6.45-13.24v-51.6c-1.36-23.76-13.92-25.8-13.92-34.28 0-4.07 3.39-8.15 8.83-8.15h55c7.47 0 10.18 4.07 10.18 12.9v69.58c0 7.47 3.39 10.18 5.43 10.18 4.41 0 8.15-2.72 16.29-10.86 25.12-28.17 43.11-71.62 43.11-71.62 2.38-5.09 6.45-9.84 15.28-9.84h35c10.52 0 12.9 5.43 10.52 12.9-4.41 20.37-47.18 80.79-47.18 80.79-3.73 6.11-5.09 8.83 0 15.61 3.73 5.09 16 15.61 24.1 25.12 14.94 17 26.48 31.23 29.53 41.07 3.45 9.84-1.65 14.93-11.49 14.93z"
                            style="fill:#fff"></path>
                    </g>
                </svg>
            </a>
        </div>

        <div class="fixed bottom-48 right-5 w-16 h-16 z-50">
            <a rel="nofollow"
                href="https://wa.me/79522326449?text=%D0%97%D0%B4%D1%80%D0%B0%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!%20%D0%AF%20%D0%BF%D0%B8%D1%88%D1%83%20%D1%81%20%D1%81%D0%B0%D0%B9%D1%82%D0%B0%20arendabc.ru%2C%20%D0%BC%D0%B5%D0%BD%D1%8F%20%D0%B8%D0%BD%D1%82%D0%B5%D1%80%D0%B8%D1%81%D1%83%D0%B5%D1%82%20"
                target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 96 96"
                    id="Whatsapp-Icon--Streamline-Svg-Logos1">
                    <path fill="url(#a1)"
                        d="M3.20676 47.591c-.00237 7.924 2.06817 15.6613 6.00506 22.4808l-6.38174 23.301 23.84542-6.2524c6.5694 3.5806 13.9665 5.4706 21.4944 5.4725h.0199c24.7897 0 44.9692-20.1724 44.9796-44.9664.0048-12.0148-4.6698-23.3123-13.1629-31.812C71.5149 7.3153 60.2212 2.63217 48.1879 2.62695 23.3953 2.62695 3.21718 22.798 3.20676 47.591Z">
                    </path>
                    <path fill="url(#b1)"
                        d="M1.60084 47.5769C1.598 55.7861 3.74293 63.8001 7.82006 70.8637L1.20947 95l24.70063-6.4765c6.8058 3.7109 14.4683 5.6672 22.2657 5.6701h.0199c25.6791 0 46.5836-20.8979 46.5945-46.5793.0042-12.4465-4.8386-24.15-13.6349-32.9544C72.3577 5.85655 60.6598 1.00521 48.1957 1 22.5119 1 1.61126 21.8945 1.60084 47.5769ZM16.3103 69.6474l-.9221-1.4641c-3.8772-6.1647-5.92355-13.2884-5.92071-20.6036C9.47603 26.2337 26.8483 8.86713 48.2104 8.86713 58.5551 8.8714 68.2777 12.904 75.59 20.221c7.3123 7.3175 11.3359 17.0448 11.333 27.3905-.0095 21.3465-17.3822 38.7154-38.7273 38.7154h-.0151c-6.9503-.0038-13.7666-1.8701-19.7114-5.3971l-1.4148-.8392-14.6578 3.8431 3.9137-14.2863Z">
                    </path>
                    <path fill="#ffffff"
                        d="M36.55 28.1053c-.8723-1.9389-1.79-1.9777-2.6197-2.0118-.6789-.0289-1.4555-.0271-2.2311-.0271-.7766 0-2.0379.2919-3.1044 1.4565-1.0675 1.1651-4.0753 3.9815-4.0753 9.7093 0 5.7284 4.1724 11.2634 4.7538 12.041.5823.7761 8.0542 12.9065 19.8876 17.5731 9.8349 3.8781 11.8363 3.1068 13.9708 2.9125 2.1345-.1938 6.8882-2.8154 7.8581-5.5341.9704-2.7182.9704-5.0484.6795-5.535-.291-.4852-1.0675-.7766-2.2317-1.3585-1.1646-.5823-6.8882-3.3991-7.9552-3.7876-1.0675-.388-1.8436-.5818-2.6202.5837-.7761 1.1642-3.0059 3.7858-3.6853 4.5624-.679.778-1.3584.8751-2.5226.2928-1.1646-.5842-4.9143-1.8123-9.3624-5.7781-3.4612-3.086-5.7976-6.8968-6.477-8.0624-.679-1.1641-.0725-1.7948.5112-2.3752.5231-.5216 1.1647-1.3593 1.747-2.0388.5809-.6799.7746-1.1651 1.1627-1.9417.3885-.777.1943-1.4569-.0967-2.0392-.2914-.5823-2.5538-6.3396-3.5891-8.6418Z">
                    </path>
                    <defs>
                        <linearGradient id="a1" x1="4519.8" x2="4519.8" y1="9077.23" y2="2.631"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#1faf38"></stop>
                            <stop offset="1" stop-color="#60d669"></stop>
                        </linearGradient>
                        <linearGradient id="b1" x1="4680.25" x2="4680.25" y1="9401.01" y2=".988"
                            gradientUnits="userSpaceOnUse">
                            <stop stop-color="#f9f9f9"></stop>
                            <stop offset="1" stop-color="#fff"></stop>
                        </linearGradient>
                    </defs>
                </svg>
            </a>
        </div>

        <div class="fixed bottom-28 right-6 w-14 h-14 z-50">
            <a href="https://t.me/Shubarin78" rel="nofollow" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 96 96"
                    id="Telegram--Streamline-Svg-Logos1">
                    <path fill="#00b6f4"
                        d="M48 1C35.5377 1 23.5747 5.95483 14.7695 14.7659 5.95703 23.5769 1 35.5399 1 48c0 12.4601 4.95703 24.4231 13.7695 33.2341C23.5747 90.0452 35.5377 95 48 95c12.4623 0 24.4253-4.9548 33.2305-13.7659C90.043 72.4231 95 60.4601 95 48c0-12.4601-4.957-24.4231-13.7695-33.2341C72.4253 5.95483 60.4623 1 48 1Z">
                    </path>
                    <path fill="#ffffff"
                        d="M22.2748 47.5041c13.7034-5.969 22.8391-9.9045 27.4069-11.8058 13.0572-5.4292 15.767-6.3722 17.5368-6.4041.3893-.0063 1.2558.0899 1.8213.5474.47.3856.6022.907.6683 1.2727.0587.3657.1395 1.1993.0734 1.8499-.705 7.4319-3.7673 25.4667-5.3242 33.7908-.6536 3.5222-1.9534 4.7031-3.2092 4.8184-2.7319.2511-4.8028-1.8036-7.4466-3.5362-4.1345-2.712-6.4698-4.3996-10.4869-7.0456-4.6412-3.0579-1.6303-4.7389 1.0135-7.4855.6903-.7189 12.7194-11.6574 12.947-12.6496.0294-.1241.0588-.5867-.2203-.8305-.2717-.2446-.6756-.1609-.9694-.0948-.4186.094-7.0206 4.4621-19.8281 13.1035-1.8727 1.2881-3.5691 1.916-5.0966 1.8829-1.6743-.036-4.9056-.9488-7.307-1.7287-2.9375-.9569-5.2801-1.4629-5.0745-3.088.1028-.846 1.2704-1.7119 3.4956-2.5968Z">

                    </path>
                    <defs>
                        <linearGradient id="a2" x1="4701" x2="4701" y1="1" y2="9401" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#2aabee"></stop>
                            <stop offset="1" stop-color="#229ed9"></stop>
                        </linearGradient>
                    </defs>
                </svg>
            </a>
        </div>
    </div>


</template>

<style scoped>
@keyframes bounce-in {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.8);
  }
  50% {
    transform: translateY(-5px) scale(1.05);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>